window.digitalData = window.digitalData || []

export default angular
    .module('syAdobeAnalytics', [])
    .service('AdobeAnalyticsService', [
        'AdobeProductModel',
        'AdobeUserModel',
        function (AdobeProductModel, AdobeUserModel) {
            var self = this
            this.pushAndUpdateData = function (data) {
                var copiedData = angular.copy(data) // Copy data to remove reference of the object
                setTimeout(function () {
                    window.digitalData.pushAndUpdate(copiedData)
                }, 3000)
            }

            this.trackPageLoad = function (AdobePageModel) {
                var data = {
                    event: 'page-loaded',
                    page: AdobePageModel,
                    user: ''
                }
                if (AdobeUserModel) {
                    data.user = AdobeUserModel
                }
                self.pushAndUpdateData(data)
            }

            this.trackFormNavigation = function (formData) {
                var data = {
                    event: 'form-navigate',
                    form: formData,
                    product: ''
                }
                if (AdobeProductModel && AdobeProductModel.name) {
                    data.product = AdobeProductModel
                }
                self.pushAndUpdateData(data)
            }
            this.trackFormInteraction = function (formData) {
                var data = {
                    event: 'form-interact',
                    form: formData,
                    product: ''
                }
                if (AdobeProductModel && AdobeProductModel.name) {
                    data.product = AdobeProductModel
                }
                self.pushAndUpdateData(data)
            }

            this.trackToolNavigation = function (toolData) {
                var data = {
                    event: 'tool-navigate',
                    tool: toolData
                }
                self.pushAndUpdateData(data)
            }
            this.trackToolInteraction = function (toolData) {
                var data = {
                    event: 'tool-interaction',
                    tool: toolData
                }

                self.pushAndUpdateData(data)
            }
            this.trackSearchNavigation = function (searchData) {
                var data = {
                    event: 'search-navigate',
                    search: searchData
                }
                self.pushAndUpdateData(data)
            }
            this.trackSearchInteraction = function (searchData) {
                var data = {
                    event: 'search-interact',
                    search: searchData
                }
                self.pushAndUpdateData(data)
            }
            this.trackVideoInteraction = function (videoData) {
                var data = {
                    event: 'video-interact',
                    video: videoData
                }
                self.pushAndUpdateData(data)
            }
        }
    ])
    .service('AdobeAnalyticsEvents', [
        'AdobeAnalyticsService',
        'AdobeUserModel',
        'AdobeFormModel',
        'AdobePageModel',
        '$timeout',
        '$rootScope',
        '$cookies',
        function (
            AdobeAnalyticsService,
            AdobeUserModel,
            AdobeFormModel,
            AdobePageModel,
            $timeout,
            $rootScope,
            $cookies
        ) {
            var self = this
            $rootScope.$on('websiteLoaded', function (event, args) {
                var referrer = ''
                if ('referrer' in document) {
                    referrer = document.referrer.toLowerCase()
                }
                AdobePageModel.destinationUrl = window.location.href
                    ? window.location.href.toLowerCase()
                    : window.location.origin.toLowerCase()
                AdobePageModel.referringUrl = referrer
                AdobePageModel.abort = false
                AdobePageModel.platform = 'sitecore'
                AdobePageModel.environment = window.currentEnvironment
                AdobePageModel.error = self.getError()
                self.setUserModel()
                AdobeAnalyticsService.trackPageLoad(AdobePageModel)
                self.assignCustomEvents()
            })
            this.setUserModel = function () {
                AdobeUserModel.authState = 'logged out'
                var xmasUser = $cookies.get('xlightuser')
                var siteUser = $cookies.get('synergy.t2c.promoCode')
                if (xmasUser || siteUser) {
                    AdobeUserModel.authState = 'logged in'
                }
                AdobeUserModel.businessPortalAccessCode = self.extractPromocode(siteUser)
            }
            this.extractPromocode = function (raw) {
                if (!raw) {
                    return null
                }
                var array = raw.split('|')
                if (array.length !== 2) {
                    return null
                }
                var data = array[0]
                var date = new Date(array[1])
                var currentDate = new Date()
                return date < currentDate ? null : data
            }
            this.getError = function () {
                var elem = document.querySelector("meta[property='og:url']")
                var content = ''
                if (elem) {
                    content = elem.getAttribute('content')
                }
                if (content && content.indexOf('404') >= 0) {
                    return '404'
                }
                return ''
            }

            $rootScope.$on('feedbackOpen', function (event, args) {
                AdobeFormModel.name = 'user feedback'
                AdobeFormModel.stage = 'start'
                AdobeFormModel.step = 1
                AdobeFormModel.stepName = 'we want your feedback'
                AdobeFormModel.type = 'engagement'
                AdobeFormModel.category = ''
                AdobeAnalyticsService.trackFormNavigation(AdobeFormModel)
            })
            $rootScope.$on('feedbackSuccess', function (event, args) {
                var surveyName = args.Reason_for_visit.toLowerCase().replace(/_/g, ' ')
                var subCategory = args.reason_for_feedback.toLowerCase().replace(/_/g, ' ')
                AdobeFormModel.name = 'user feedback'
                AdobeFormModel.stage = 'complete'
                AdobeFormModel.step = 2
                AdobeFormModel.stepName = 'thank you for your feedback'
                AdobeFormModel.type = 'engagement'
                AdobeFormModel.category = surveyName
                AdobeFormModel.subCategory = subCategory
                AdobeAnalyticsService.trackFormNavigation(AdobeFormModel)
            })
            $rootScope.$on('campaignOpen', function (event, args) {
                AdobeFormModel.name = 'campaign feedback'
                AdobeFormModel.stage = 'start'
                AdobeFormModel.step = 1
                AdobeFormModel.stepName = 'we want your feedback'
                AdobeFormModel.type = 'engagement'
                AdobeFormModel.category = ''
                AdobeAnalyticsService.trackFormNavigation(AdobeFormModel)
            })
            $rootScope.$on('campaignSuccess', function (event, args) {
                AdobeFormModel.name = 'campaign feedback'
                AdobeFormModel.stage = 'complete'
                AdobeFormModel.step = 2
                AdobeFormModel.stepName = 'thank you for your feedback'
                AdobeFormModel.type = 'engagement'
                AdobeFormModel.category = ''
                AdobeFormModel.subCategory = ''
                AdobeAnalyticsService.trackFormNavigation(AdobeFormModel)
            })
            this.assignCustomEvents = function () {
                self.assignEventsToAnchor()
                self.assignEventstoSurvey()
                self.assignEventstoWebChat()
            }
            this.compileCustomTagElement = function (el) {
                el.injector().invoke([
                    '$compile',
                    function ($compile) {
                        $compile(el)(el.scope())
                    }
                ])
            }
            this.assignEventstoSurvey = function () {
                angular.element(document).ready(function () {
                    $timeout(function () {
                        var el = angular.element(document.getElementsByClassName('usabilla_live_button_container'))
                        if (el.length > 0) {
                            self.assignCustomTagElement(el, 'survey', 'prompted')
                        }
                    }, 10000)
                })
            }
            this.assignEventstoWebChat = function () {
                angular.element(document).ready(function () {
                    $timeout(function () {
                        var el = angular.element(document.getElementById('inside_liveChatTab'))
                        if (el.length > 0) {
                            self.assignCustomTagElement(el, 'web chat', 'prompted')
                        }
                    }, 10000)
                })
            }
            this.assignEventsToAnchor = function () {
                $timeout(function () {
                    var anchors = document.querySelectorAll('a')
                    for (var i = 0; i < anchors.length; i++) {
                        var link = anchors[i]
                        if (link.href.indexOf('tel') >= 0) {
                            var el = angular.element(link)
                            if (el.length > 0) {
                                var telNumber = link.pathname
                                self.assignCustomTagElement(el, 'click to call', telNumber)
                            }
                        }
                    }
                }, 5)
            }
            this.assignCustomTagElement = function (el, type, description) {
                var elm = el[0]
                elm.setAttribute('data-event', 'site-interaction')
                elm.setAttribute('data-type', type)
                elm.setAttribute('data-location', 'body')
                elm.setAttribute('data-description', description)
                self.compileCustomTagElement(el)
            }
            this.isFormStart = false
            this.focusedformControls = []
            this.trackFormStart = function ($scope, attrs) {
                if (!self.isFormStart) {
                    AdobeFormModel.name = attrs.adobeFormName
                        ? attrs.adobeFormName
                        : $scope.adobeFormName
                        ? $scope.adobeFormName.toLowerCase()
                        : ''
                    AdobeFormModel.stage = 'start'
                    AdobeFormModel.step = '1'
                    AdobeFormModel.stepName = attrs.adobeStepName
                        ? attrs.adobeStepName
                        : $scope.adobeStepName
                        ? $scope.adobeStepName
                        : 'request a call back'
                    AdobeFormModel.type = attrs.adobeFormType
                        ? attrs.adobeFormType
                        : $scope.adobeFormType
                        ? $scope.adobeFormType
                        : 'lead'
                    AdobeFormModel.category = attrs.category ? attrs.category : $scope.category ? $scope.category : ''
                    AdobeFormModel.subCategory = attrs.subCategory
                        ? attrs.subCategory
                        : $scope.subCategory
                        ? $scope.subCategory
                        : ''
                    AdobeFormModel.referenceId = ''
                    AdobeFormModel.error = ''
                    AdobeAnalyticsService.trackFormNavigation(AdobeFormModel)
                    self.isFormStart = true
                } else {
                    AdobeFormModel.stage = 'incomplete'
                }
            }
            this.trackElementsFocus = function ($scope, attrs) {
                var elementName = attrs.name ? attrs.name.toLowerCase() : ''
                var elementId = attrs.id ? attrs.id.toLowerCase() : ''
                $scope.focusedformControls = $scope.focusedformControls || []
                $timeout(function () {
                    if (self.focusedformControls.indexOf(elementName) < 0) {
                        AdobeFormModel.lastFieldInteractedId = elementId
                        AdobeFormModel.lastFieldInteractedName = elementName
                        AdobeAnalyticsService.trackFormInteraction(AdobeFormModel)
                        self.focusedformControls.push(elementName)
                    }
                }, 1)
            }
            this.startedSteps = []
            this.trackSmartHomePlan = function ($scope, attrs) {
                if (self.startedSteps.indexOf($scope.adobeStep) < 0) {
                    var stage =
                        $scope.adobeStep === '1' ? 'start' : $scope.adobeStep === '4' ? 'complete' : 'incomplete'
                    var stepName =
                        $scope.adobeStep === '1'
                            ? 'your account'
                            : $scope.adobeStep === '2'
                            ? 'select a meter'
                            : $scope.adobeStep == '3'
                            ? 'review and confirm'
                            : $scope.adobeStep == '4'
                            ? "you're done"
                            : ''
                    AdobeFormModel.name = 'smart home plan switch'
                    AdobeFormModel.stage = stage
                    AdobeFormModel.step = $scope.adobeStep
                    AdobeFormModel.stepName = stepName
                    AdobeFormModel.type = 'lead'
                    AdobeAnalyticsService.trackFormNavigation(AdobeFormModel)
                    self.startedSteps.push($scope.adobeStep)
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsForm', [
        'AdobeAnalyticsEvents',
        '$timeout',
        function (AdobeAnalyticsEvents, $timeout) {
            return {
                restrict: 'A',
                require: ['form'],
                link: function ($scope, $element, attrs, ngModel) {
                    var myForm = ngModel[0] ? ngModel[0] : 'No Form'
                    $scope.adobeFormName = attrs.syAdobeAnalyticsForm
                        ? attrs.syAdobeAnalyticsForm
                        : $scope.adobeFormName
                    $scope.adobeFormType = attrs.adobeFormType ? attrs.adobeFormType : $scope.adobeFormType
                    $scope.adobeStepName = attrs.adobeStepName ? attrs.adobeStepName : $scope.adobeStepName
                    angular.forEach(myForm, function (value, key) {
                        if (typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, '$modelValue')) {
                            var el = angular.element(document.getElementsByName(key))
                            if (el.length > 0) {
                                angular.forEach(el, function (elem, key) {
                                    elem.onfocus = function () {
                                        $timeout(function () {
                                            switch ($scope.adobeFormName) {
                                                case 'smart home plan switch':
                                                    AdobeAnalyticsEvents.trackSmartHomePlan($scope, elem)
                                                    break
                                                default:
                                                    AdobeAnalyticsEvents.trackFormStart($scope, elem)
                                            }
                                            AdobeAnalyticsEvents.trackElementsFocus($scope, elem)
                                        }, 10)
                                    }
                                })
                            }
                        }
                    })
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsBody', [
        'AdobeAnalyticsEvents',
        '$timeout',
        function (AdobeAnalyticsEvents, $timeout) {
            return {
                restrict: 'A',
                require: ['body']
            }
        }
    ])
    .directive('syAdobeAnalyticsFocus', [
        'AdobeAnalyticsEvents',
        function (AdobeAnalyticsEvents) {
            return {
                restrict: 'A',
                link: function ($scope, $element, attrs, ngModel) {
                    $element.bind('focus', function () {
                        AdobeAnalyticsEvents.trackFormStart($scope, attrs)
                        AdobeAnalyticsEvents.trackElementsFocus($scope, attrs)
                    })
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsFormComplete', [
        'AdobeFormModel',
        'AdobeAnalyticsService',
        '$timeout',
        function (AdobeFormModel, AdobeAnalyticsService, $timeout) {
            return {
                scope: true,
                restrict: 'AE',
                link: function ($scope, $element, attrs, ngModel) {
                    $timeout(function () {
                        AdobeFormModel.name = attrs.adobeFormName
                            ? attrs.adobeFormName.toLowerCase()
                            : $scope.adobeFormName
                            ? $scope.adobeFormName.toLowerCase()
                            : ''
                        AdobeFormModel.stage = 'complete'
                        AdobeFormModel.step = attrs.adobeStep
                            ? attrs.adobeStep
                            : $scope.adobeStep
                            ? $scope.adobeStep
                            : '2'
                        AdobeFormModel.stepName = attrs.adobeStepName
                            ? attrs.adobeStepName
                            : $scope.adobeStepName
                            ? $scope.adobeStepName
                            : 'thanks'
                        AdobeFormModel.type = attrs.adobeFormType
                            ? attrs.adobeFormType
                            : $scope.adobeFormType
                            ? $scope.adobeFormType
                            : 'lead'
                        AdobeFormModel.category = attrs.category
                            ? attrs.category
                            : $scope.category
                            ? $scope.category
                            : ''
                        AdobeFormModel.subCategory = attrs.subCategory
                            ? attrs.subCategory
                            : $scope.subCategory
                            ? $scope.subCategory
                            : ''
                        AdobeFormModel.referenceId = attrs.adobeReferenceId ? attrs.adobeReferenceId : ''
                        AdobeFormModel.error = ''
                        AdobeAnalyticsService.trackFormNavigation(AdobeFormModel)
                    }, 5)
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsProduct', [
        'AdobeProductModel',
        '$timeout',
        function (AdobeProductModel, $timeout) {
            return {
                scope: false,
                restrict: 'E',
                link: function ($scope, $element, attrs, ngModel) {
                    $timeout(function () {
                        AdobeProductModel.name = attrs.productName
                        AdobeProductModel.id = attrs.productId
                    }, 1)
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsToolStart', [
        'AdobeToolModel',
        'AdobeAnalyticsService',
        '$timeout',
        function (AdobeToolModel, AdobeAnalyticsService, $timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element, attrs, ngModel) {
                    $element.bind('blur', function () {
                        trackToolStart()
                    })
                    var trackToolStart = function () {
                        $timeout(function () {
                            if (!$scope.isToolStart) {
                                AdobeToolModel.name = attrs.toolName.toLowerCase()
                                AdobeToolModel.stage = 'start'
                                AdobeToolModel.step = '1'
                                AdobeToolModel.stepName = attrs.stepName ? attrs.stepName.toLowerCase() : ''
                                AdobeToolModel.type = attrs.toolType ? attrs.toolType : 'engagement'
                                AdobeToolModel.category = attrs.category ? attrs.category : ''
                                AdobeAnalyticsService.trackToolNavigation(AdobeToolModel)
                                $scope.isToolStart = true
                            }
                        }, 0)
                    }
                    if (attrs.onLoad) {
                        trackToolStart()
                    }
                    $scope.isToolStart = false
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsToolComplete', [
        'AdobeToolModel',
        'AdobeAnalyticsService',
        '$timeout',
        function (AdobeToolModel, AdobeAnalyticsService, $timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element, attrs, ngModel) {
                    $element.bind('click', function () {
                        $timeout(function () {
                            AdobeToolModel.name = attrs.toolName.toLowerCase()
                            AdobeToolModel.stage = 'complete'
                            AdobeToolModel.step = attrs.step ? attrs.step : '2'
                            AdobeToolModel.stepName = attrs.stepName ? attrs.stepName.toLowerCase() : ''
                            AdobeToolModel.type = attrs.toolType ? attrs.toolType : 'engagement'
                            AdobeToolModel.category = attrs.category ? attrs.category : ''
                            AdobeAnalyticsService.trackToolNavigation(AdobeToolModel)
                        }, 0)
                    })
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsToolResult', [
        'AdobeToolModel',
        'AdobeAnalyticsService',
        '$timeout',
        function (AdobeToolModel, AdobeAnalyticsService, $timeout) {
            return {
                scope: false,
                restrict: 'E',
                link: function ($scope, $element, attrs, ngModel) {
                    $timeout(function () {
                        AdobeToolModel.name = attrs.toolName.toLowerCase()
                        AdobeToolModel.stage = 'result'
                        AdobeToolModel.step = ''
                        AdobeToolModel.stepName = attrs.stepName ? attrs.stepName : 'results'
                        AdobeToolModel.type = attrs.toolType ? attrs.toolType : 'engagement'
                        AdobeToolModel.category = attrs.category ? attrs.category : ''
                        AdobeAnalyticsService.trackToolNavigation(AdobeToolModel)
                    }, 20)
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsToolInteraction', [
        'AdobeToolModel',
        'AdobeAnalyticsService',
        '$timeout',
        function (AdobeToolModel, AdobeAnalyticsService, $timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element, attrs, controller) {
                    $element.bind('click', function () {
                        $timeout(function () {
                            var label = attrs.syAdobeAnalyticsToolInteraction
                                ? attrs.syAdobeAnalyticsToolInteraction.toLowerCase()
                                : ''
                            AdobeToolModel.name = attrs.toolName.toLowerCase()
                            AdobeToolModel.stage = attrs.stage || AdobeToolModel.stage
                            AdobeToolModel.step = attrs.step || AdobeToolModel.step
                            AdobeToolModel.stepName = attrs.stepName ? attrs.stepName : 'results'
                            AdobeToolModel.type = attrs.toolType ? attrs.toolType : 'engagement'
                            AdobeToolModel.category = attrs.category ? attrs.category : ''
                            AdobeToolModel.label = label
                            AdobeAnalyticsService.trackToolInteraction(AdobeToolModel)
                            if (attrs.syHref) {
                                if (attrs.syHref === 'goback') {
                                    window.history.back()
                                } else {
                                    window.location = attrs.syHref
                                }
                            }
                        }, 0)
                    })
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsSearchNavigate', [
        'AdobeSearchModel',
        'AdobeAnalyticsService',
        '$timeout',
        function (AdobeSearchModel, AdobeAnalyticsService, $timeout) {
            return {
                scope: false,
                restrict: 'E',
                link: function ($scope, $element, attrs, ngModel) {
                    $timeout(function () {
                        var resultCount = attrs.resultCount ? attrs.resultCount : 0
                        var searchTerm = attrs.searchTerm ? attrs.searchTerm.toLowerCase() : ''
                        AdobeSearchModel.resultsCount = resultCount
                        AdobeSearchModel.term = searchTerm
                        AdobeAnalyticsService.trackSearchNavigation(AdobeSearchModel)
                    }, 20)
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsSearchInteract', [
        'AdobeSearchModel',
        'AdobeAnalyticsService',
        '$timeout',
        function (AdobeSearchModel, AdobeAnalyticsService, $timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element, attrs, controller) {
                    $element.bind('click', function () {
                        $timeout(function () {
                            var resultPostion = attrs.resultPosition ? attrs.resultPosition : ''
                            var resultUrl = attrs.syHref ? attrs.syHref.toLowerCase() : ''
                            var resultText = $element[0] ? $element[0].text : ''
                            AdobeSearchModel.resultClicked = resultText
                            AdobeSearchModel.positionClicked = resultPostion
                            AdobeSearchModel.resultUrl = resultUrl
                            AdobeAnalyticsService.trackSearchInteraction(AdobeSearchModel)
                            if (attrs.syHref) {
                                if (attrs.syHref === 'goback') {
                                    window.history.back()
                                } else {
                                    window.location = attrs.syHref
                                }
                            }
                        }, 0)
                    })
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsFormError', [
        'AdobeFormModel',
        'AdobeAnalyticsService',
        '$timeout',
        function (AdobeFormModel, AdobeAnalyticsService, $timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element, attrs, ngModel) {
                    $timeout(function () {
                        var error =
                            $element.length > 0 && $element[0].innerText
                                ? $element[0].innerText
                                : attrs.syAdobeAnalyticsFormError
                                ? attrs.syAdobeAnalyticsFormError
                                : 'validation'
                        if (error != 'validation') {
                            error = 'server - ' + error
                        }
                        AdobeFormModel.name = attrs.adobeFormName
                            ? attrs.adobeFormName.toLowerCase()
                            : $scope.adobeFormName
                        AdobeFormModel.stage = 'incomplete'
                        AdobeFormModel.step = attrs.step ? attrs.step : '1'
                        AdobeFormModel.stepName = attrs.adobeStepName
                            ? attrs.adobeStepName
                            : $scope.adobeStepName
                            ? $scope.adobeStepName
                            : 'request a call back'
                        AdobeFormModel.type = attrs.adobeFormType
                            ? attrs.adobeFormType
                            : $scope.adobeFormType
                            ? $scope.adobeFormType
                            : 'lead'
                        AdobeFormModel.referenceId = attrs.adobeReferenceId ? attrs.adobeReferenceId : ''
                        AdobeFormModel.error = error
                        AdobeAnalyticsService.trackFormNavigation(AdobeFormModel)
                    }, 5)
                }
            }
        }
    ])
    .directive('syAdobeAnalyticsToolError', [
        'AdobeToolModel',
        'AdobeAnalyticsService',
        '$timeout',
        function (AdobeToolModel, AdobeAnalyticsService, $timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element, attrs, ngModel) {
                    $timeout(function () {
                        var error =
                            $element.length > 0 && $element[0].innerText
                                ? $element[0].innerText
                                : attrs.syAdobeAnalyticsToolError
                                ? attrs.syAdobeAnalyticsToolError
                                : 'validation'
                        AdobeToolModel.name = attrs.toolName.toLowerCase()
                        AdobeToolModel.stage = 'incomplete'
                        AdobeToolModel.step = ''
                        AdobeToolModel.stepName = attrs.stepName ? attrs.stepName : 'results'
                        AdobeToolModel.type = attrs.toolType ? attrs.toolType : 'engagement'
                        AdobeToolModel.category = attrs.category ? attrs.category : ''
                        AdobeToolModel.error = error
                        AdobeAnalyticsService.trackToolNavigation(AdobeToolModel)
                    }, 5)
                }
            }
        }
    ])
    .directive('syToggleIdTrack', [
        'AdobeAnalyticsEvents',
        function (AdobeAnalyticsEvents) {
            return {
                restrict: 'A',
                link: function ($scope, elem, attrs) {
                    elem.bind('click', function (event) {
                        if (event.currentTarget.attributes.class.value == 'faq-title') {
                            elem.attr('data-event', 'site-interaction')
                            elem.attr('data-location', 'body')
                            elem.attr('data-type', 'accordion')
                            elem.attr('data-description', event.currentTarget.text)
                        } else {
                            elem.removeAttr('data-event')
                                .removeAttr('data-type')
                                .removeAttr('data-location')
                                .removeAttr('data-description')
                        }
                    })
                }
            }
        }
    ])
    .factory('AdobePageModel', function () {
        return {
            destinationUrl: '',
            pageName: '',
            referringUrl: '',
            abort: '',
            platform: '',
            environment: 'engagement',
            virtualUrl: ''
        }
    })
    .factory('AdobeUserModel', function () {
        return {
            userIdHashed: '',
            authState: '',
            userType: '',
            businessPortalNumber: '',
            businessPortalAccessCode: ''
        }
    })
    .factory('AdobeToolModel', function () {
        return {
            name: '',
            stage: '',
            step: '',
            stepName: '',
            type: 'engagement',
            category: '',
            error: '',
            label: ''
        }
    })
    .factory('AdobeFormModel', function () {
        return {
            name: '',
            stage: '',
            step: '',
            stepName: '',
            type: '',
            category: '',
            subCategory: '',
            error: '',
            referenceId: ''
        }
    })
    .factory('AdobeProductModel', function () {
        return {
            name: '',
            id: ''
        }
    })
    .factory('AdobeSearchModel', function () {
        return {
            searchType: 'global search',
            resultsCount: '',
            term: '',
            resultClicked: '',
            positionClicked: '',
            resultUrl: ''
        }
    })
    .factory('AdobeVideoModel', function () {
        return {
            id: '',
            player: 'youtube',
            title: '',
            stage: ''
        }
    })
    .service('VideoAdobeAnalyticsService', [
        '$window',
        'AdobeAnalyticsService',
        'AdobeVideoModel',
        '$timeout',
        function ($window, AdobeAnalyticsService, AdobeVideoModel, $timeout) {
            var youtubePlayers = {}
            var percentageInterval
            var trackedPercentage = 0
            // Return the title of a video
            // @param player {object} YouTube player object
            function getVideoTitle(player) {
                return player.getVideoData().title
            }
            function getVideoId(player) {
                return player.getVideoData().video_id
            }
            // Return the current state of the player during an event
            // @param event {object} The YT event containing the current state
            function getPlayerAction(event) {
                switch (event.data) {
                    case YT.PlayerState.PLAYING:
                        percentageInterval = setInterval(function () {
                            trackPercentage(event.target)
                        }, 2000)
                        return 'start'
                    case YT.PlayerState.PAUSED:
                        clearInterval(percentageInterval)
                        return 'pause'
                    case YT.PlayerState.BUFFERING:
                        clearInterval(percentageInterval)
                        return 'buffering'
                    case YT.PlayerState.ENDED:
                        clearInterval(percentageInterval)
                        return 'complete'
                }
                return null
            }
            // Track percentage viewed in percentages of 25%
            // @param player {object} YouTube player object
            function trackPercentage(player) {
                var currentPercentage = player.getCurrentTime() / player.getDuration()
                if (currentPercentage > trackedPercentage + 0.25) {
                    trackedPercentage += 0.25
                }
            }
            // Listen for play/pause events
            // @params event {object} YouTube API event object
            function onPlayerStateChange(event) {
                var playerAction = getPlayerAction(event)
                var videoTitle = getVideoTitle(event.target)
                var videoId = getVideoId(event.target)
                if (playerAction) {
                    AdobeVideoModel.id = videoId
                    AdobeVideoModel.title = videoTitle
                    AdobeVideoModel.stage =
                        playerAction == 'start' || playerAction == 'complete' ? playerAction : 'incomplete'
                    AdobeAnalyticsService.trackVideoInteraction(AdobeVideoModel)
                }
            }
            // Listen for player to be loaded and ready
            // @param event {object} YouTube API event object
            function onPlayerReady(event) {
                var videoTitle = getVideoTitle(event.target)
            }
            // Add YouTube API callbacks to the global scope and then load the API
            function loadYouTubeAPI(callback) {
                // Callback is called when YouTube API is ready for the provided video
                $timeout(function () {
                    $window.onYouTubeIframeAPIReady = callback
                }, 20)
                // Load the Youtube JS API
                var firstScript = document.getElementsByTagName('script')[0]
                var apiScript = document.createElement('script')
                apiScript.src = 'https://www.youtube.com/iframe_api'
                apiScript.async = true
                apiScript.id = 'ytapi'
                firstScript.parentNode.insertBefore(apiScript, firstScript)
            }
            // Instantiate a new player object for an embedded video iframe
            // @param iframe {object} IFRAME DOM element
            this.registerPlayer = function registerPlayer($iframe) {
                function bindYouTubeEvents() {
                    var iframeSrc = $iframe[0].src
                    if (!youtubePlayers[iframeSrc]) {
                        youtubePlayers[iframeSrc] = new YT.Player($iframe[0], {
                            events: {
                                onReady: onPlayerReady,
                                onStateChange: onPlayerStateChange
                            }
                        })
                    }
                }
                // If the API has not been loaded, load the API before
                // Binding player events
                if (typeof YT === 'undefined') {
                    return loadYouTubeAPI(bindYouTubeEvents)
                }
                return bindYouTubeEvents()
            }
        }
    ])
